import {z} from 'zod';

export const DispensingUnitsPresetsFormSchema = z.object({
  value: z.number(),
});

export type DispensingUnitsPresetsForm = z.infer<typeof DispensingUnitsPresetsFormSchema>;
